import { createSidecarMedium } from "./auth-service-tools1140.js";
var effectCar = createSidecarMedium();
export { effectCar };